var React = require('react');

function PillBottle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.5 3c.412 0 .75-.337.75-.75V.75A.752.752 0 0011.5 0H1a.752.752 0 00-.75.75v1.5c0 .413.337.75.75.75h10.5zm-1.25 13c.55 0 1-.45 1-1V4h-10v2H5a.25.25 0 01.25.25v.5A.25.25 0 015 7H1.25v2H5a.25.25 0 01.25.25v.5A.25.25 0 015 10H1.25v2H5a.25.25 0 01.25.25v.5A.25.25 0 015 13H1.25v2c0 .55.45 1 1 1h8z","fillRule":"evenodd"}));
}

PillBottle.defaultProps = {"viewBox":"0 0 13 16"};

module.exports = PillBottle;

PillBottle.default = PillBottle;
